import * as React from 'react';
import styles from './my-downloads.scss';
import { ReportsView } from './reports-view/reports-view';
import { ExportsView } from './exports/exports-view/exports-view';
import { STATE } from 'app/constants';
import { myDownloadsTranslations } from 'app/area/my-downloads/constants';
import { containerFactory } from 'app/infrastructure/redux/index';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export class MyDownloadsComponent extends React.Component<any, void> {
  public static statePath: string = STATE.myDownloads;

  public componentDidMount() {
    scrollToTop();
  }

  public render() {
    const { translation } = this.props;
    return (<MainGridContainer className={styles.myDownloadsView}>
      <div className={styles.downloadItemsWrapper}>
        <div className="page-heading">
          <h1>{translation.my_downloads_title}</h1>
          <p>{translation.my_downloads_subtitle}</p>
        </div>
        <div className="row">
          <div className="col-md-6">
            <ReportsView />
          </div>
          <div className="col-md-6">
            <ExportsView />
          </div>
        </div>
      </div>
    </MainGridContainer>);
  }
}

const container = containerFactory(MyDownloadsComponent, {}, {}, myDownloadsTranslations);

export { container as MyDownloads };
